import URLS from '../../../util/urls'
import axios from 'axios'

const state = {
  form: {
    id: 0,
    nome: undefined
  },

  formPesquisa: {
    nome: ''
  },

  caracteristicasCondominios: [],

  quantidadeCaracteristicas: 0
}

const mutations = {
  atualizarCaracteristicas(state, payload) {
    state.caracteristicasCondominios = payload
  },

  atualizarCaracteristicaSelecionada(state, payload) {
    state.form.id = payload.id
    state.form.nome = payload.nome
  },

  limparForm(state) {
    state.form = {
      id: 0,
      nome: ''
    }
  },

  limparFormPesquisa(state) {
    state.formPesquisa = {
      nome: ''
    }
  },

  setQuantidadeCaracteristica(state, payload) {
    state.quantidadeCaracteristicas = payload;
  }
}

const actions = {
  limparForm(context) {
    context.commit('limparForm');
  },

  limparFormPesquisa(context) {
    context.commit('limparFormPesquisa');
  },

  listarCaracteristicas(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_IMOVEL_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarCaracteristicas', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarCaracteristicas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarCaracteristicas', response.data.lista)
          context.commit('setQuantidadeCaracteristica', response.data.quantidade)
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  gravarCaracteristica(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_IMOVEL_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarCaracteristica', payload);
            }
          }).catch(error => {
            throw error
          });
        default:
          context.commit('atualizarCaracteristicaSelecionada', response.data.item)
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarCaracteristica(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_IMOVEL_RECUPERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarCaracteristica', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarCaracteristicaSelecionada', response.data);
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerCaracteristica(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_IMOVEL_REMOVER, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              context.dispatch('removerCaracteristica', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          if(response.data.status !== 'FALHA') {
            context.commit('limparForm')
          }
          return response.data;
      }
    }).catch(error => {
       throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}